let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kRbFj")).then(() => parcelRequire('98aOv'));